import React, { useState, useRef, useEffect, useCallback, useMemo } from "react";
import LineIcon from '../../assets/images/dashboard/Line.svg';
import CalenderIcon from '../../assets/images/dashboard/calender.svg';
import ShieldIcon from '../../assets/images/dashboard/shield.svg';
import SearchIcon from '../../assets/images/dashboard/search.svg';
import { Button, DropdownList, Input } from "../../common/commonIndex";
import { Image } from "../componentIndex";
import LocationIcon from '../../assets/images/doctorProfile/map-marker.svg';
import InsuranceIcon from '../../assets/images/insurance.svg';
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import { format } from "date-fns";
import PatientService from '../../services/API/patientService';
import GoogleMapService from '../../services/API/googleMapService';
import { toast } from "react-toastify";
import { useAuthenticationContext } from '../../services/slices/AuthenticationSlicer';
import { useNavigate } from "react-router-dom";
import useDebounce from "hooks/useDebounce";
import debounce from "lodash/debounce";

const MainSearch = ({ onChange, isSearch, setIsSearch, isHeader, queryParamData, isLaning, className }) => {
    const navigate = useNavigate();
    const [anywhere, setAnywhere] = useState(queryParamData?.place || '');
    // const [nextAvailable, setNextAvailable] = useState(queryParamData?.startDate && queryParamData?.endDate  ? `${queryParamData?.startDate ? format(queryParamData?.startDate, 'MMM dd') : ''}-${queryParamData?.endDate ? format(queryParamData?.endDate, 'dd') : ''}` : '');
    const [nextAvailable, setNextAvailable] = useState(
        queryParamData?.startDate && queryParamData?.endDate &&
            !isNaN(new Date(queryParamData.startDate)) && !isNaN(new Date(queryParamData.endDate))
            ? `${format(new Date(queryParamData.startDate), 'MMM dd')}-${format(new Date(queryParamData.endDate), 'dd')}`
            : ''
    );
    const [isNear, setIsNear] = useState(false);
    const [isNextAvailable, setIsNextAvailable] = useState(false);
    const [mobile, setMobile] = useState(false);

    const [isAnyInsurance, setIsAnyInsurance] = useState(false);
    const [anyInsurance, setAnyInsurance] = useState(null);
    const [anyInsuranceId, setAnyInsuranceId] = useState(queryParamData?.insId || null);
    const [insurances, setInsurances] = useState([]);
    const [filteredInsurances, setFilteredInsurances] = useState([]);

    const [placeId, setPlaceId] = useState('');
    const [searchNearList, setSearchNearList] = useState([]);
    const [calenderValue, setCalenderValue] = useState([null], [null]);
    const [startDate, setStartDate] = useState(queryParamData?.startDate || null);
    const [endDate, setEndDate] = useState(queryParamData?.endDate || null);
    const datePickerRef = useRef(null);
    const dropdownMenuRef = useRef(false);
    const dropdownListRef = useRef(false);
    const { state: data } = useAuthenticationContext();
    const [locations, setLocations] = useState({ lat: null, lng: null });
    const [error, setError] = useState("");
    let isSearchNearBy = false;

    const [state, setState] = useState({
        anywhere: 'Atlanta, GA' || '',
        nextAvailable: 'Sept 30-31' || '',
        anyInsurance: 'Blue Cross Blue Shield' || '',
    });
    
    const handleButtonClick = async () => {
        let placeDetails = await getPlaceDetails(placeId);

        const startDateFr = startDate && !isNaN(new Date(startDate)?.getTime())
            ? format(new Date(startDate), 'yyyy-MM-dd')
            : null;

        const endDateFr = endDate && !isNaN(new Date(endDate)?.getTime())
            ? format(new Date(endDate), 'yyyy-MM-dd')
            : null;
        const searchData = {
            place: anywhere ? anywhere : null,
            lat: placeDetails ? placeDetails?.geometry?.location?.lat : queryParamData?.lat ? queryParamData?.lat : locations?.lat ? locations.lat : 33.5185892, 
            lng: placeDetails ? placeDetails?.geometry?.location?.lng : queryParamData?.lng ? queryParamData?.lng : locations?.lng ? locations.lng : -86.8103567,
            startDate: startDateFr ? startDateFr : null,
            endDate: endDateFr ? endDateFr : null,
            insurance: anyInsurance ? anyInsurance : null,
            insuranceId: anyInsurance !== '' && anyInsurance && anyInsuranceId ? anyInsuranceId : null
        };

        if (isHeader) {
            const queryParamsStr = "place=" + searchData.place + "&lat=" + searchData.lat + "&lng=" + searchData.lng + "&startDate=" + searchData.startDate + "&endDate=" + searchData.endDate + "&insId=" + searchData.insuranceId;
            navigate(`${window.location.pathname}?${queryParamsStr + window.location.hash}`, { replace: true });
        }
        else {
            onChange(searchData);
        }
    };

    const handleNextAvailableChange = (e) => {
        if (e?.target?.value === undefined || !e?.target?.value) {
            setStartDate(null)
            setEndDate(null)
        }

        setNextAvailable(e?.target?.value || '');
        setState((prevState) => ({
            ...prevState,
            nextAvailable: e?.target?.value || '',
        }));
        setIsNextAvailable(false);
    };

    const handleAnyInsuranceChange = (value) => {
        const anyinsuranceValue = value || '';
        setAnyInsurance(anyinsuranceValue);
        setIsAnyInsurance(true);
        setState((prevState) => ({
            ...prevState,
            anyInsurance: anyinsuranceValue,
        }));
        const filteredInsurances = insurances.filter(is => is.name?.toLowerCase().includes(anyinsuranceValue.toLowerCase()));
        setFilteredInsurances(filteredInsurances);
    };

    const handleEvent = () => {
        setIsNear(!isNear);
        setIsNextAvailable(false);
        setIsAnyInsurance(false);
    }

    const handleNextEvent = () => {
        setIsNextAvailable(!isNextAvailable);
        setIsNear(false);
        setIsAnyInsurance(false);
    }

    const handleAnyInsuranceEvent = () => {
        setIsAnyInsurance(!isAnyInsurance);
        setIsNextAvailable(false);
        setIsNear(false);
    }

    const getAllInsuranceProvider = async () => {
        try {
            // const accessToken = data?.userData?.result?.token;
            const response = await PatientService.getAllInsuranceProvider();
            if (response?.statusCode === 200) {
                setInsurances(response.result);
                localStorage.setItem('insurance_provider', JSON.stringify(response.result));
                setFilteredInsurances(response.result);
                if (!anyInsurance && anyInsuranceId) {
                    const insuranceName = response.result.find(r => r.id == anyInsuranceId)?.name;
                    setAnyInsurance(insuranceName);
                }
            } else {
                setInsurances([])
                setFilteredInsurances([]);
                //toast.error(response?.message);
            }
            return response;
        } catch (error) {
            console.error("Login failed: ", error);
        }
    }

    const handleSearch = (searchField) => {
        onChange();
        setIsSearch(!isSearch);
        if (searchField === 'nearMe') {
            setIsNear(true);
        }
        if (searchField === 'nextAvailabel') {
            setIsNextAvailable(true);
        }
        if (searchField === 'chooseInsurance') {
            setIsAnyInsurance(true);
        }

    }
    useEffect(() => {
        getLatLog();
        setMobile(window.innerWidth < 700);
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const getLatLog = () => {
        if ("geolocation" in navigator) {
            // Get the user's current position
            navigator.geolocation.getCurrentPosition(
                async (position) => {
                    const { latitude, longitude } = position.coords;
                    setLocations({ lat: latitude, lng: longitude });

                    // Reverse geocode to get the placeId
                    // const placeId = await getPlaceIdFromCoordinates(latitude, longitude);
                    // setPlaceId(placeId);
                },
                (err) => {
                    setError(err.message || "Unable to retrieve location");
                },
                {
                    enableHighAccuracy: true,
                    timeout: 10000,
                    maximumAge: 0,
                }
            );
        } else {
            setError("Geolocation is not supported by your browser.");
        }
    }

    const getPlaceIdFromCoordinates = async (lat, lng) => {
        return new Promise((resolve, reject) => {
            const geocoder = new window.google.maps.Geocoder();
            const latLng = new window.google.maps.LatLng(lat, lng);

            // Reverse geocode the coordinates
            geocoder.geocode({ location: latLng }, (results, status) => {
                if (status === "OK" && results[0]) {
                    resolve(results[0].place_id); // Extract the placeId
                } else {
                    reject("Place ID not found");
                }
            });
        });
    };

    useEffect(() => {
        getAllInsuranceProvider();
    }, [insurances?.length === 0]);

    const handleClickOutside = (event) => {
        if (
            dropdownMenuRef.current &&
            !dropdownMenuRef.current.contains(event.target)
        ) {

            setIsNear(false);

            if (isNextAvailable) {
                setIsNextAvailable(false);
            }

            if (isAnyInsurance) {
                setIsAnyInsurance(false);
            }

        }
        if (
            datePickerRef.current &&
            !datePickerRef.current.contains(event.target)
        ) {
            setIsNextAvailable(false);

            if (isNear) {
                setIsNear(false);
            }

            if (isAnyInsurance) {
                setIsAnyInsurance(false);
            }
        }
        if (
            dropdownListRef.current &&
            !dropdownListRef.current.contains(event.target)
        ) {
            setIsAnyInsurance(false);

            if (isNear) {
                setIsNear(false);
            }
            if (isNextAvailable) {
                setIsNextAvailable(false);
            }
        }
    };

    const today = new Date();
    // Memoize calenderOnChange to avoid creating a new instance on each render useCallback
    const calenderOnChange = (dates) => {
        const [start, end] = dates;
        // const startDate = new Date(start);
        // const endDate = new Date(end);
        const startDate = start && !isNaN(new Date(start).getTime()) ? new Date(start) : new Date();
        const endDate = end && !isNaN(new Date(end).getTime()) ? new Date(end) : new Date();

        // const formattedRange = `${format(startDate, 'MMM dd')}-${format(endDate, 'dd')}`;
        const formattedRange =
            startDate && endDate && !isNaN(new Date(startDate)) && !isNaN(new Date(endDate))
                ? `${format(new Date(startDate), 'MMM dd')}-${format(new Date(endDate), 'dd')}`
                : '';
        setStartDate(start);
        setEndDate(end);
        setCalenderValue(dates);
        setNextAvailable(formattedRange);
        if (start && end) {
            setIsNextAvailable(false);
        }
        setState((prevState) => ({
            ...prevState,
            nextAvailable: formattedRange || '',
        }));
    };

    const dayClassName = (date) => {
        const isToday =
            date.getDate() === today.getDate() &&
            date.getMonth() === today.getMonth() &&
            date.getFullYear() === today.getFullYear();
        // Add class if date is before today and it's not today itself
        if (date < today && !isToday) {
            return 'disabled-before-today'; // Class for days before today
        }

        return ''; // No class for valid days and today itself
    };

    const handlePlaceSelect = (item) => {
        setState((prevState) => ({
            ...prevState,
            anywhere: item.description || '',
        }));
        setIsNear(false);
        setAnywhere(item.description);
        setPlaceId(item.place_Id);
    }

    const handleInsuranceSelect = (item) => {
        setState((prevState) => ({
            ...prevState,
            anyInsurance: item.name || '',
        }));
        setIsAnyInsurance(false);
        setAnyInsurance(item.name);
        setAnyInsuranceId(item.id);
    }

    const handleAnyWhereChange = (e) => {
        isSearchNearBy = true;
        setAnywhere(e || '');
        if (e === '') {
            setIsNear(!isNear);
        } else {
            setIsNear(isNear);
        }

        setState((prevState) => ({
            ...prevState,
            anywhere: e || '',
        }));
        debouncedFetchSuggestions(e);
    };
    const sendBackendRequest = useCallback((value) => {
        fetchSuggestions(value)
    }, []);

    const fetchSuggestions = async (input) => {
        if (!input) {
            setSearchNearList([]);
            return;
        }
        fetchLocation(input);
    };
    const fetchLocation = async (input) => {
        const searchValue = isSearchNearBy ? input : anywhere;
        const response = await GoogleMapService.fetchAuthcomplete(input || anywhere);
        if (response.statusCode == 200) {
            let findCityState;
            if (response?.result?.predictions?.length > 0) {
                findCityState = filterCitiesAndStates(response?.result?.predictions);
            }
            // Filter unique data using Map based on 'description'
            const uniqueData = Array.from(
                new Map(findCityState?.map(item => [item.description, item])).values()
            );
            setSearchNearList(uniqueData);
        }
        else {
            setSearchNearList([]);
        }
    }

    // const filterCitiesAndStates = (places) => {
    //     return places.filter(place => {
    //         // Match only places with the format 'City, State, Country'
    //         const regex = /^[^,]+, [A-Z]{2}, [A-Z]+$/;
    //         const cityState = place.description.split(', ').slice(-3).join(', '); // Get last 3 parts (city, state, country)
    //         return regex.test(cityState);
    //     }).map(place => {
    //         const cityState = place.description.split(', ').slice(-3).join(', '); // Get last 3 parts (city, state, country)
    //         return { description: cityState, place_Id: place.place_Id };
    //     });
    // }
    const filterCitiesAndStates = (places) => {
        return places.filter(place => {
            // Match places with the format 'City, State, Country' or similar (allowing flexibility)
            const regex = /^[^,]+, [^,]+, [^,]+$/;
            const parts = place.description.split(', ');
            const cityState = parts.slice(-3).join(', '); // Get last 3 parts (city, state, country if present)
            return regex.test(cityState); // Check if it matches the pattern
        }).map(place => {
            const parts = place.description.split(', ');
            const cityState = parts.slice(-3).join(', '); // Get last 3 parts (city, state, country if present)
            return { description: cityState, place_Id: place.place_Id };
        });
    };

    const debouncedFetchSuggestions = useMemo(() => {
        return debounce(sendBackendRequest, 1000);
    }, [sendBackendRequest]);

    const getPlaceDetails = async () => {
        if (placeId) {
            const response = await GoogleMapService.getPlaceDetails(placeId);
            if (response.statusCode == 200) {
                return response.result.result;
            }
            return { geometry: { location: { lat: 0, lng: 0 } } };
        }
    };

    const getCurrentDate = (afterFiveDays) => {
        afterFiveDays?.setDate(afterFiveDays.getDate() + 5);
        // Format the future date (optional)
        const formattedFutureDate = afterFiveDays.toISOString().split("T")[0]; // YYYY-MM-DD
        const findAfterFiveDays = new Date(formattedFutureDate);
        return findAfterFiveDays;
    }

    return (
        // {/* Search Bar */ }
        <div className={` ${className} ${isHeader ? 'header-search-filter' : ''}`}>
            <div className="search-bar " >
                <div className="d-flex align-items-center">
                    <Image imgUrl={LineIcon} altText={'anywhere'} className={'anywhere'} />
                    <div className="dropdown search-Anywhere">
                        <div className={`btn btn-secondary dropdown-toggle anywhere-input`} onClick={handleEvent} href="#" role="button" data-bs-toggle="dropdown" aria-expanded={isNear ? true : false}>
                            <Input
                                inputType="text"
                                inputPlaceholder="Near me"
                                className="form-control"
                                value={anywhere}
                                onChange={handleAnyWhereChange}
                            />
                        </div>
                        {isNear && anywhere && (
                            <ul className={`dropdown-menu ${isNear ? 'active' : ''}`} ref={dropdownMenuRef}>
                                <div className={`${searchNearList?.length > 0 ? 'scrollbar search-near-scrollbar' : ''}`} >
                                    <div className={`${searchNearList?.length > 0 ? 'force-overflow' : ''}`}>
                                        {searchNearList?.length > 0 ? (
                                            searchNearList?.map((item, index) => (
                                                <li key={index} onClick={() => handlePlaceSelect(item)}>
                                                    <a className="dropdown-item" href="#" onClick={(e) => e.preventDefault()}>
                                                        <Image imgUrl={LocationIcon} className={'map-icon'} /> <span>{item.description}</span>
                                                    </a>
                                                </li>
                                            ))
                                        ) : (
                                            <div className="not-found-txt">
                                                <p className="mb-0">No location in search criteria</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </ul>
                        )}
                    </div>
                </div>
                <div className="d-flex align-items-center">
                    <Image imgUrl={CalenderIcon} altText={'calendar'} className={'calendar-icon'} />
                    <div className="dropdown search-Anywhere">
                        <div className={`btn btn-secondary dropdown-toggle `} onClick={handleNextEvent} href="#" role="button" data-bs-toggle="dropdown" aria-expanded={isNextAvailable ? true : false}>
                            <Input
                                inputType="text"
                                inputPlaceholder="Next available"
                                className="form-control"
                                value={nextAvailable}
                                onChange={handleNextAvailableChange}
                            />
                        </div>
                        {isNextAvailable && (
                            <div className={`dropdown-menu calendar-dropdown ${isNextAvailable ? 'active' : ''}`} ref={datePickerRef}>
                                {/* <div className="scrollbar search-near-scrollbar">
                                            <div className="force-overflow"> */}
                                <div className="calendar-container">
                                    <DatePicker
                                        onChange={calenderOnChange}
                                        selected={startDate}
                                        inline
                                        dayClassName={dayClassName}
                                        calendarStartDay={0}
                                        locale="it"
                                        startDate={startDate}
                                        endDate={endDate}
                                        selectsRange
                                        monthsShown={mobile ? 1 : 2} //
                                        minDate={getCurrentDate(new Date())} // Disable past dates new Date()
                                        disabledKeyboardNavigation
                                    />
                                </div>
                                {/* </div>
                                            </div> */}
                            </div>
                        )}

                    </div>
                </div>
                <div className="d-flex align-items-center">
                    <Image imgUrl={ShieldIcon} altText={'insurance'} className={'shield-icon'} />
                    <div className="dropdown search-Anywhere" >
                        <div className={`btn btn-secondary dropdown-toggle `} onClick={handleAnyInsuranceEvent}>
                            <Input
                                inputType="text"
                                inputPlaceholder="Any insurance"
                                className="form-control"
                                value={anyInsurance}
                                onChange={handleAnyInsuranceChange}
                            />
                        </div>
                        {isAnyInsurance && (
                            <ul className={`dropdown-menu ${isAnyInsurance ? 'active' : ''}`} ref={dropdownListRef}>
                                <div className={` ${insurances?.length > 0 ? 'scrollbar search-near-scrollbar' : ''}`}>
                                    <div className={`${insurances?.length > 0 ? 'force-overflow' : ''}`}>
                                        {filteredInsurances?.length > 0 ? (
                                            filteredInsurances.map((item, index) => (
                                                <li key={index} onClick={() => handleInsuranceSelect(item)}>
                                                    <DropdownList Icon={InsuranceIcon} item={item} index={index} />
                                                </li>
                                            ))
                                        ) : (
                                            <div className="not-found-txt">
                                                <p className="mb-0">No insurance provider in search criteria</p>
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </ul>
                        )}
                    </div>
                </div>
                <Button
                    btnClass="search-button"
                    btnType="button"
                    btnName="Search"
                    btnImage={SearchIcon}
                    btnImgAlt="Search"
                    btnImgCName="search-icon"
                    onClick={handleButtonClick}
                    isDisabled={true}
                />
            </div >
        </div>
    );
};

export default MainSearch;